import { getSSRRenderInputs } from '@confluence/ssr-utilities/entry-points/ssrRenderInputs.ts';

const STABLE_UI_PARAM = 'stableUI=1';

/**
 * To be used by E2E/playwright/Criterion tests, to ensure UI is predictable upon the initial load:
 *  - the side nav is always expanded to its default width
 *  - no changeboarding dialogs are shown
 *  - no banners are shown
 *
 * The previous implementation gated this behind a Statsig kill switch (cc_e2e_stable_ui), but
 * Statsig is not yet initialised when this is called during SSR rendering (React renders before
 * initializeClientFromValues fires in bifrost). This caused the cookie consent banner to appear
 * in SSR VR tests even with stableUI=1 in the URL. The URL param itself is a sufficient guard —
 * only test infrastructure passes stableUI=1, so no Statsig gate is needed.
 */
export const isStableUIEnabledForTests = (): boolean => {
	// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
	return process.env.REACT_SSR
		? (getSSRRenderInputs().uri ?? '').includes(STABLE_UI_PARAM)
		: (window.location.search ?? '').includes(STABLE_UI_PARAM);
};
